import { jsx as _jsx } from "react/jsx-runtime";
import { range } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { useLocale } from '../../hooks';
import styles from './PdfViewer.module.scss';
const options = {
    cMapUrl: './cmaps/',
    cMapPacked: true,
    standardFontDataUrl: './standard_fonts/',
};
// Use the worker file that webpack copies to the static directory
// Use relative path so it works with the /{region}/{client}/ URL structure
pdfjs.GlobalWorkerOptions.workerSrc = './pdf.worker.min.js';
export const PdfViewer = ({ url }) => {
    const divRef = useRef(null);
    const { t } = useLocale();
    const [numPages, setNumPages] = useState(0);
    const [width, setWidth] = useState(1000);
    const handleLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };
    useEffect(() => {
        if (divRef.current) {
            setWidth(divRef.current.offsetWidth);
        }
    }, []);
    return (_jsx("div", { className: styles.pdfViewer, ref: divRef, children: _jsx(Document, { className: styles.document, options: options, file: url, loading: t('Loading PDF'), onLoadSuccess: handleLoadSuccess, error: t('Failed to load PDF'), externalLinkTarget: '_blank', children: range(0, numPages).map(page => (_jsx("div", { children: _jsx(Page, { className: styles.page, width: width, pageIndex: page }, page) }, page))) }) }));
};
